import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Moon, BookOpen } from "lucide-react";
import { fetchJournal } from "@/lib/api";

const ease = [0.22, 1, 0.36, 1];

const fmt = (iso) => {
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch (e) {
    return "";
  }
};

export const RitualJournal = ({ refreshKey = 0 }) => {
  const [entries, setEntries] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchJournal()
      .then(setEntries)
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [refreshKey]);

  if (loaded && entries.length === 0) return null; // stays hidden until she completes one

  return (
    <div className="mt-10" data-testid="ritual-journal">
      <div className="flex items-center gap-3">
        <BookOpen size={16} className="text-[#C5A059]" />
        <p className="overline text-[0.6rem]">Your Lunar Diary — Completed Rituals</p>
      </div>
      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
        {entries.map((e, i) => (
          <motion.div
            key={e.id || i}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: (i % 2) * 0.06, ease }}
            className="rounded-2xl border border-[#C5A059]/15 bg-[#070707] p-6"
            data-testid="journal-entry"
          >
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-2 text-[#C5A059]">
                <Moon size={15} />
                <span className="text-[0.65rem] uppercase tracking-[0.16em]">
                  {e.event_type === "new" ? "New Moon" : "Full Moon"} · {e.sign}
                </span>
              </div>
              <span className="font-mono text-[0.55rem] uppercase tracking-[0.14em] text-white/30">
                {fmt(e.completed_at)}
              </span>
            </div>
            <h4 className="mt-3 font-serif text-xl font-light text-white">{e.title}</h4>
            {e.reflection && (
              <p className="mt-2 text-sm font-light italic leading-relaxed text-white/55">
                “{e.reflection}”
              </p>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default RitualJournal;
